<template>
  <zg-module
    v-bind="moduleProps"
    class="zg-faq-section"
    background-color="beige"
  >
    <slot
      slot="sub-title"
      name="sub-title"
    />

    <zg-faq
      :faqs="items"
      :show-structured-data="false"
    />
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgFaq from '../../ZgFaq/ZgFaq.vue'
  import ZgModule from '../ZgModule/ZgModule.vue'

  /**
   * A section for displaying FAQs
   */
  export default {
    name: 'ZgFaqSection',
    components: {
      ZgModule,
      ZgFaq
    },
    mixins: [module],
    props: {
      /**
       * An Array of FAQs. Should include a `question` and an `answer`.
       */
      items: {
        type: Array,
        required: true
      }
    }
  }
</script>
